// M/D/YY from an ISO date (or Date); a blank stays a dash. Date-only strings are read as local dates so they never shift a day.
export function shortDate(iso) {
  if (!iso) return "—";
  const d = typeof iso === "string" && /^\d{4}-\d{2}-\d{2}$/.test(iso) ? new Date(`${iso}T00:00:00`) : new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return `${d.getMonth() + 1}/${d.getDate()}/${String(d.getFullYear()).slice(-2)}`;
}

// Money always shows two decimals.
export function money(n) {
  return (Number(n) || 0).toLocaleString("en-US", { style: "currency", currency: "USD" });
}

// Right-aligned number columns with lined-up digits.
export function num(n, digits = 0) {
  if (n == null || n === "") return "—";
  return (Number(n) || 0).toLocaleString("en-US", { minimumFractionDigits: digits, maximumFractionDigits: digits });
}
